
define('template!galleryImageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="image-ctn">\n  <img>\n</div>';

}
return __p
};});

